import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  className?: string;
  small?: boolean;
}
export const CountdownTimer: React.FC<CountdownTimerProps> = ({
  className = '',
  small = false
}) => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 5,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prevTime => {
        const newSeconds = prevTime.seconds - 1;
        const newMinutes = newSeconds < 0 ? prevTime.minutes - 1 : prevTime.minutes;
        const newHours = newMinutes < 0 ? prevTime.hours - 1 : prevTime.hours;
        return {
          hours: newHours < 0 ? 0 : newHours,
          minutes: newMinutes < 0 ? 59 : newMinutes,
          seconds: newSeconds < 0 ? 59 : newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const timerSize = small ? 'text-base sm:text-lg' : 'text-xl sm:text-2xl md:text-3xl';
  const labelSize = small ? 'text-[8px] sm:text-[10px]' : 'text-[10px] sm:text-xs';
  return <div className={`flex items-center justify-center gap-1 sm:gap-3 ${className}`} data-id="element-353">
      <div className="bg-[#0A0A0A] border border-[#E0B84C]/50 rounded-lg px-2 sm:px-4 py-1 sm:py-3 text-center min-w-[50px] sm:min-w-[70px]" data-id="element-354">
        <div className={`${timerSize} font-bold text-[#E0B84C]`} data-id="element-355">
          {timeLeft.hours.toString().padStart(2, '0')}
        </div>
        <div className={`${labelSize} text-gray-400 uppercase font-medium`} data-id="element-356">
          HORAS
        </div>
      </div>
      <div className="text-[#E0B84C] font-bold text-xl sm:text-3xl" data-id="element-357">:</div>
      <div className="bg-[#0A0A0A] border border-[#E0B84C]/50 rounded-lg px-2 sm:px-4 py-1 sm:py-3 text-center min-w-[50px] sm:min-w-[70px]" data-id="element-358">
        <div className={`${timerSize} font-bold text-[#E0B84C]`} data-id="element-359">
          {timeLeft.minutes.toString().padStart(2, '0')}
        </div>
        <div className={`${labelSize} text-gray-400 uppercase font-medium`} data-id="element-360">
          MIN
        </div>
      </div>
      <div className="text-[#E0B84C] font-bold text-xl sm:text-3xl" data-id="element-361">:</div>
      <div className="bg-[#0A0A0A] border border-[#E0B84C]/50 rounded-lg px-2 sm:px-4 py-1 sm:py-3 text-center min-w-[50px] sm:min-w-[70px]" data-id="element-362">
        <div className={`${timerSize} font-bold text-[#E0B84C]`} data-id="element-363">
          {timeLeft.seconds.toString().padStart(2, '0')}
        </div>
        <div className={`${labelSize} text-gray-400 uppercase font-medium`} data-id="element-364">
          SEG
        </div>
      </div>
    </div>;
};